// https://github.com/russellgoldenberg/scrollama
require('intersection-observer');
var Scrollama = require('scrollama');

const hiddenClass = 'fade-in-hidden';
const finishedClass = 'fade-in-finished';
const offsetStart = 0.75;

class LazyLoad {
  constructor(classes) {
    let classesString = classes.join(', ');
    this.el = $(classesString).not('.' + finishedClass);
    if (this.el.length == 0) {
      return;
    }
    this.el.addClass(hiddenClass);

    const scroller = Scrollama();

    scroller
      .setup({
        step: this.el.toArray(),
        offset: offsetStart,
        debug: false
      })
      .onStepEnter(response => {
        $(response.element).removeClass(hiddenClass).addClass(finishedClass);
      });

    // setup resize event
    window.addEventListener("resize", scroller.resize);
  }
}

module.exports = {
  LazyLoad
};